import { jsx as _jsx } from "react/jsx-runtime";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import styles from "./river-checkbox.module.scss";
import clsx from "clsx";
import { useFormField } from "../../../hooks";
export const RiverCheckbox = (props) => {
    var _a, _b;
    const { label, checked, disabled, onChange } = useFormField(props);
    return (_jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: checked, onChange: onChange, name: props.id, color: "primary", classes: {
                root: clsx([styles.checkBox, (_a = props.classes) === null || _a === void 0 ? void 0 : _a.checkbox]),
            } }), label: label, classes: {
            root: clsx([
                styles.formControl,
                props.className,
                { [styles.smallerIcon]: !!props.smallerIcon },
            ]),
            label: clsx([styles.label, (_b = props.classes) === null || _b === void 0 ? void 0 : _b.label]),
        }, disabled: disabled }));
};
